import createLucideIcon from '../createLucideIcon';

const Table = createLucideIcon('TableIcon', [
  [
    'rect',
    {
      x: '3',
      y: '3',
      width: '18',
      height: '18',
      rx: '2',
      ry: '2',
      key: 'maln0c',
    },
  ],
  ['line', { x1: '3', y1: '9', x2: '21', y2: '9', key: '1uch6j' }],
  ['line', { x1: '3', y1: '15', x2: '21', y2: '15', key: '1xojw2' }],
  ['line', { x1: '12', y1: '3', x2: '12', y2: '21', key: 'essbwb' }],
]);

export default Table;
